import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Paper,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Button,
  Drawer,
  ListItemIcon,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Fade,
  Stack,
  Select,
  IconButton,
  AppBar,
  Toolbar,
  Slide,
  InputLabel,
  CssBaseline,
  ToggleButtonGroup,
  ToggleButton,
  Link,
  CircularProgress,
  Menu,
  TextField,
  InputAdornment,
  SvgIcon,
  Skeleton,
  Breadcrumbs,
  Chip,
  Tabs,
  Tab,
} from "@mui/material";
import {
  AttachMoney,
  Category,
  Business,
  TrendingUp,
  TrendingDown,
  Remove,
  PieChart,
  Close as CloseIcon,
  CloudUpload,
  Dashboard,
  FileDownload,
  CheckCircle,
  RadioButtonUnchecked,
  AccessTime,
  AutoAwesome,
  Campaign,
  Delete,
  ArrowDropDown,
  ArrowDropDownCircle,
  PriceCheck,
  CreditScore,
  CurrencyExchange,
  Info,
  Groups,
  PersonSearch,
  HelpOutline,
  Speed,
  PanToolAlt,
  TrendingFlat,
  PeopleAltOutlined,
  CampaignOutlined,
  FiberManualRecord,
  AccessTimeFilledOutlined,
  AccessTimeFilled,
  Co2,
  EnergySavingsLeaf,
  Insights,
  InsightsOutlined,
  ArrowUpward,
  ArrowDownward,
  HorizontalRule,
  TrendingUpOutlined,
  TrendingDownOutlined,
  TrendingFlatOutlined,
  FilterCenterFocus,
  TipsAndUpdates,
  NavigateNext,
  ReportProblem,
  CloseFullscreen,
  Close,
  OpenInNew,
  Toll,
  TrendingUpSharp,
  TrendingDownSharp,
  TrendingFlatSharp,
  LinkOffOutlined,
  LinkRounded,
  Visibility,
  ArrowOutward,
  PlayArrow,
} from "@mui/icons-material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RxDashboard } from "react-icons/rx";
import { RiBuildingLine } from "react-icons/ri";
import { Tooltip as MUITooltip } from "@mui/material";
import { LoadingGif } from "../LoadingGif";
import { AnimatedInfoCard } from "../LoadingGif";
import { SupplierChartFunc } from "../SupplierChart";
import { SupplierInsightContainer } from "../SupplierTable";
import { HistogramChart } from "../CategoryChart";
import { InsightContainer } from "../CategoryInsights";
import { CarbonChart } from "../CarbonEmissions";

const AnalyticsSectionCM = ({
  top3CategoriesSup,
  supDandP,
  supCustInfo,
  riskScore,
  scoreCommentary,
  revenue,
  supplierNews,
  spendSummary,
  supplierProData,
  kpdbData,
  roleTitle,
  topcardCommentary,
  costStructureMovements,
  topMovementsAnalysis,
  porterForces,
  supplierChartData,
  globalSummaries,
  indiSummaries,
  categorySummary,
  filteredResults,
  carbonTable,
  supplierSummary,
  carbonEmission,
  marketImplications,
  catandSpend,
  csSrc,
  categoryNews,
  clientNames,
  categoryChartData,
  categoryChartDataL1,
  topSuppliers,
  demandandSupply,
  costStructure,
  categoryDict,
  marketSize,
  topContributors,
  topCategories,
  card,
  card1,
  card2,

}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const toggleExpand = () => {
    setOpenDialog(true);
    console.log("toggleExpand is called");
  };
  const handleClose = () => setOpenDialog(false);

  const [selectedView, setSelectedView] = useState("keyInsights");

  const handleToggleChange = (event, newValue) => {
    if (newValue !== null) {
      setSelectedView(newValue);
    }
  };
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 3,
        // bgcolor: "#181921",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        marginLeft: "-2rem",
        marginTop: "30px",
        width: "100%",
      }}
    >
      {/* Company Details Section */}
      {/* <Box
              id="Company Details"
              style={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  fontStyle: "Roboto",
                  fontSize: "18px",
                  fontWeight: 700,
                  lineHeight: "18px",
                  color: "white",
                }}
              >
                <Info sx={{ mr: 0.5 }} /> Company Details
              </Typography>
              <Box sx={{ width: "100%", height: "1px", mb: 2 }} />
              <Box sx={{ width: "100%" }}>
                {clientInsights ? (
                  <Box
                    sx={{
                      mb: 2,
                      display: "flex",
                      background: "#FFFFFF08",
                      color: "white",
                      justifyContent: "space-between",
                      border: "1px solid #2C2D3C",
                      borderRadius: "8px",
                      width: "100%",
                      padding: "16px",
                      fontSize: "14px",
                      boxShadow: "0px 1px 2px 0px #1018280D",
                    }}
                  >
                    <Typography
                      sx={{
                        fontStyle: "Roboto",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "left",
                      }}
                    >
                      {clientInsights}
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "240px", // Adjust height as needed
                    }}
                  >
                    <LoadingGif />
                  </Box>
                )}
              </Box>
            </Box> */}

      {/* Summary Section */}
      <Box
        id="Company Details"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
        }}
      >
        <Box sx={{ width: "100%", height: "1px", mb: 2 }} />
        <Box sx={{ width: "100%" }}>
          {/* {clientInsights ? (
                  <Box
                    sx={{
                      mb: 2,
                      display: "flex",
                      background: "#FFFFFF08",
                      color: "white",
                      justifyContent: "space-between",
                      border: "1px solid #2C2D3C",
                      borderRadius: "8px",
                      width: "100%",
                      padding: "16px",
                      fontSize: "14px",
                      boxShadow: "0px 1px 2px 0px #1018280D",
                    }}
                  >
                    <Typography
                      sx={{
                        fontStyle: "Roboto",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "left",
                      }}
                    >
                      {clientInsights}
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "240px", // Adjust height as needed
                    }}
                  >
                    <LoadingGif />
                  </Box>
                )} */}

          <Box
            sx={{
              mb: 2,
              display: "flex",
              flexDirection: "column",
              background: "#FFFFFF08",
              color: "white",
              border: "1px solid #2C2D3C",
              borderRadius: "8px",
              width: "100%",
              padding: "16px",
              fontSize: "14px",
              boxShadow: "0px 1px 2px 0px #1018280D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontStyle: "Roboto",
                  fontSize: "18px",
                  fontWeight: 700,
                  lineHeight: "18px",
                  color: "white",
                }}
              >
                <AutoAwesome sx={{ mr: 1 }} /> Key Takeaways
              </Typography>
              {/* Right: View Full Summary / Collapse */}
              <Box
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <>
                  <Button
                    onClick={toggleExpand}
                    variant="contained"
                    sx={{
                      fontStyle: "Inter",
                      fontWeight: 600,
                      fontSize: "12px",
                      color: "white",
                      padding: "6px 8px",
                      borderRadius: "4px",
                      textTransform: "none",
                      backgroundColor: "#BE3FF5",
                      "&:hover": {
                        backgroundColor: "#BE3FF5",
                      },
                    }}
                  >
                    View key takeaways
                  </Button>
                </>
              </Box>
            </Box>

            <Dialog
              open={openDialog}
              onClose={handleClose}
              fullWidth
              maxWidth="lg"
              PaperProps={{
                sx: {
                  backgroundColor: "#1C1C1E",
                  color: "white",
                  borderRadius: "12px",
                },
              }}
            >
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: 700,
                  fontSize: "18px",
                  fontStyle: "Roboto",
                  color: "white",
                }}
              >
                {/* Group icon and text together */}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <AutoAwesome sx={{ mr: 1 }} />
                  Key Takeaways
                </Box>

                {/* Right: Close button + Toggle buttons */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <ToggleButtonGroup
                    value={selectedView} // should be a state variable like 'keyInsights' or 'recommendations'
                    exclusive
                    onChange={handleToggleChange} // function to handle view switch
                    sx={{
                      backgroundColor: "#FFFFFF1A",
                      borderRadius: "6px",
                      "& .MuiToggleButton-root": {
                        color: "white",
                        fontSize: "12px",
                        padding: "4px 10px",
                        border: "none",
                        fontStyle: "Roboto",
                        textTransform: "none",
                        "&.Mui-selected": {
                          backgroundColor: "#BE3FF5",
                          color: "white",
                        },
                      },
                    }}
                  >
                    <ToggleButton value="keyInsights">
                      Key Insights
                    </ToggleButton>
                    <ToggleButton value="recommendations">
                      Recommendations
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <IconButton onClick={handleClose} sx={{ color: "white" }}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </DialogTitle>

              <DialogContent>
                <>
                  <Box>
                    <>
                      {categorySummary?.category_summary?.category_results &&
                        Object.entries(
                          categorySummary.category_summary.category_results
                        ).map(([category, data]) => (
                          <Box key={category} sx={{ mt: 2, ml: 1 }}>
                            {selectedView === "keyInsights" && (
                            <Box
                              sx={{
                                border: "1px solid #FFFFFF1A",
                                borderRadius: "8px",
                                boxShadow: "0px 1px 2px 0px #1018280D",
                                padding: "12px",
                                backgroundColor: "#FFFFFF0F",
                              }}
                            >
                              <Typography sx={{ fontWeight: 600, mb: 1 }}>
                                Spend Evolution
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  mb: 1,
                                }}
                              >
                                {/* <span
                              style={{
                                marginRight: "8px",
                                color: "#FFFFFF",
                                fontSize: "14px",
                              }}
                            >
                              •
                            </span> */}
                                <span style={{ fontSize: "14px" }}>
                                  Over the time period of{" "}
                                  {data.top_80_l3_dict.year}, {category} spend
                                  has seen{" "}
                                  {data.percent_spend_change >= 0 ? "an" : "a"}{" "}
                                  {data.percent_spend_change >= 0
                                    ? "increase"
                                    : "decrease"}{" "}
                                  by{" "}
                                  <span
                                    style={{
                                      color:
                                        data.percent_spend_change >= 0
                                          ? "#F44336"
                                          : "#4CAF50",
                                    }}
                                  >
                                    {data.percent_spend_change >= 0 ? "▲" : "▼"}{" "}
                                    {Math.abs(
                                      data.percent_spend_change
                                    ).toFixed(0)}
                                    %
                                  </span>
                                </span>
                              </Box>

                              <Typography sx={{ fontWeight: 600, mb: 1 }}>
                                Category Composition
                              </Typography>

                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  mb: 1,
                                }}
                              >
                                {/* <span
                              style={{
                                marginRight: "8px",
                                color: "#FFFFFF",
                                fontSize: "14px",
                              }}
                            >
                              •
                            </span> */}
                                <span style={{ fontSize: "14px" }}>
                                  The {category} category comprises{" "}
                                  <span
                                    style={{
                                      color: "#4CAF50",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {data.top_80_l3_dict.num_l3_categories}{" "}
                                    subcategories
                                  </span>
                                  , with{" "}
                                  {Object.entries(
                                    data.top_80_l3_dict.top_80_categories
                                  )
                                    .sort((a, b) => b[1] - a[1])
                                    .map(
                                      (
                                        [l3Category, percentage],
                                        index,
                                        array
                                      ) => (
                                        <React.Fragment key={l3Category}>
                                          {index === array.length - 1 &&
                                          array.length > 1
                                            ? "and "
                                            : ""}
                                          {l3Category} contributing{" "}
                                          <span style={{ color: "#F44336" }}>
                                            {percentage.toFixed(0)}%
                                          </span>
                                          {index < array.length - 2
                                            ? ", "
                                            : index === array.length - 2
                                            ? ", "
                                            : ""}
                                        </React.Fragment>
                                      )
                                    )}{" "}
                                  of total spend
                                </span>
                              </Box>
                            </Box>
                            )}
                          </Box>
                        ))}

                      {costStructureMovements &&
                        costStructureMovements.length > 0 && (
                          <Box sx={{ mt: 2, ml: 1, mb: 2 }}>
                            <Box
                              sx={{
                                border: "1px solid #FFFFFF1A",
                                borderRadius: "8px",
                                boxShadow: "0px 1px 2px 0px #1018280D",
                                padding: "12px",
                                backgroundColor: "#FFFFFF0F",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  mb: 1,
                                }}
                              >
                                {selectedView === "recommendations"
                                  ? "Category recommendations"
                                  : "Market Outlook"}
                              </Typography>

                              {/* Show insight_high, insight_low, and insight_moderate in bullet points */}
                              {selectedView === "recommendations" && (
                                <Box
                                  component="ul"
                                  sx={{
                                    paddingLeft: 2,
                                    margin: 0,
                                    listStyleType: "disc",
                                  }}
                                >
                                  {filteredResults.recommendations.map(
                                    (recommendation, index) => (
                                      <li key={index}>
                                        <Typography
                                          sx={{
                                            fontSize: "14px",
                                            color: "white",
                                          }}
                                        >
                                          {recommendation}
                                        </Typography>
                                      </li>
                                    )
                                  )}
                                </Box>
                              )}
                              {costStructureMovements &&
                                costStructureMovements.length > 0 && (
                                  <Box>
                                    {selectedView === "keyInsights" && (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "flex-start",
                                          marginBottom: "12px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            marginRight: "8px",
                                            color: "#FFFFFF",
                                            fontSize: "14px",
                                          }}
                                        >
                                          •
                                        </span>
                                        <span style={{ fontSize: "14px" }}>
                                          <i> Price Evolution: </i>
                                          {(() => {
                                            // Get the primary category key (to be excluded)
                                            const primaryCategoryKey =
                                              Object.keys(
                                                filteredResults.result
                                              )[0];

                                            // Get other categories, sorted by absolute movement value, excluding the primary category
                                            const otherCategories =
                                              costStructureMovements
                                                .filter(
                                                  (item) =>
                                                    item.category !==
                                                    primaryCategoryKey
                                                )
                                                .sort(
                                                  (a, b) =>
                                                    Math.abs(b.movement) -
                                                    Math.abs(a.movement)
                                                )
                                                .slice(0, 3); // Get top 3 by movement magnitude

                                            // Handle case where no valid other categories exist
                                            if (otherCategories.length === 0) {
                                              const primaryCategory =
                                                costStructureMovements.find(
                                                  (item) =>
                                                    item.category ===
                                                    primaryCategoryKey
                                                );

                                              if (!primaryCategory) {
                                                return null; // No valid data to show
                                              }

                                              return (
                                                <>
                                                  <i>Price Evolution</i>:{" "}
                                                  <span>
                                                    {primaryCategory.category}
                                                  </span>{" "}
                                                  price has{" "}
                                                  {primaryCategory.movement > 0
                                                    ? "increased"
                                                    : "decreased"}{" "}
                                                  by{" "}
                                                  <span
                                                    style={{
                                                      color:
                                                        primaryCategory.movement >
                                                        0
                                                          ? "#F44336"
                                                          : "#4CAF50",
                                                    }}
                                                  >
                                                    {primaryCategory.movement >
                                                    0
                                                      ? "▲"
                                                      : "▼"}{" "}
                                                    {Math.abs(
                                                      primaryCategory.movement
                                                    ).toFixed(0)}
                                                    %
                                                  </span>{" "}
                                                  over the past 12 months.
                                                </>
                                              );
                                            }

                                            // Split categories into increasing and decreasing
                                            const increasingCategories =
                                              otherCategories.filter(
                                                (item) => item.movement > 0
                                              );
                                            const decreasingCategories =
                                              otherCategories.filter(
                                                (item) => item.movement <= 0
                                              );

                                            // Format increasing categories with 'and' dynamically
                                            const increasePart =
                                              increasingCategories.length > 0
                                                ? increasingCategories
                                                    .map(
                                                      (item, index) =>
                                                        `${item.category}${
                                                          index ===
                                                          increasingCategories.length -
                                                            2
                                                            ? " and"
                                                            : index <
                                                              increasingCategories.length -
                                                                1
                                                            ? ","
                                                            : ""
                                                        }`
                                                    )
                                                    .join(" ")
                                                : null;

                                            const increaseMovements =
                                              increasingCategories.length > 0
                                                ? increasingCategories
                                                    .map(
                                                      (item) =>
                                                        `<span style="color:#F44336;">▲ ${item.movement.toFixed(
                                                          0
                                                        )}%</span>`
                                                    )
                                                    .join(" and ")
                                                : null;

                                            // Format decreasing categories with correct grammar
                                            const decreasePart =
                                              decreasingCategories.length > 0
                                                ? decreasingCategories
                                                    .map(
                                                      (item, index) =>
                                                        `${item.category}${
                                                          index ===
                                                          decreasingCategories.length -
                                                            2
                                                            ? " and"
                                                            : index <
                                                              decreasingCategories.length -
                                                                1
                                                            ? ","
                                                            : ""
                                                        }`
                                                    )
                                                    .join(" ")
                                                : null;

                                            const decreaseMovements =
                                              decreasingCategories.length > 0
                                                ? decreasingCategories
                                                    .map(
                                                      (item) =>
                                                        `<span style="color:#4CAF50;">▼ ${Math.abs(
                                                          item.movement
                                                        ).toFixed(0)}%</span>`
                                                    )
                                                    .join(" and ")
                                                : null;

                                            // Handle scenarios based on available data
                                            if (increasePart && decreasePart) {
                                              return (
                                                <>
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html: `Among the top 3 subcategories, ${increasePart} ${
                                                        increasingCategories.length ===
                                                        1
                                                          ? "has"
                                                          : "have"
                                                      } shown significant increase in price movements by ${increaseMovements} respectively, while ${decreasePart} ${
                                                        decreasingCategories.length ===
                                                        1
                                                          ? "has"
                                                          : "have"
                                                      } shown a significant decrease in price movements by ${decreaseMovements} over the past 12 months.`,
                                                    }}
                                                  />
                                                </>
                                              );
                                            } else if (increasePart) {
                                              return (
                                                <span
                                                  dangerouslySetInnerHTML={{
                                                    __html: `Among the top 3 subcategories, ${increasePart} ${
                                                      increasingCategories.length ===
                                                      1
                                                        ? "has"
                                                        : "have"
                                                    } shown significant increase in price movements by ${increaseMovements} respectively over the past 12 months.`,
                                                  }}
                                                />
                                              );
                                            } else if (decreasePart) {
                                              return (
                                                <span
                                                  dangerouslySetInnerHTML={{
                                                    __html: `Among the top 3 subcategories, ${decreasePart} ${
                                                      decreasingCategories.length ===
                                                      1
                                                        ? "has"
                                                        : "have"
                                                    } shown a significant decrease in price movements by ${decreaseMovements} over the past 12 months.`,
                                                  }}
                                                />
                                              );
                                            } else {
                                              return (
                                                <>
                                                  No significant price movements
                                                  were observed among the top 3
                                                  subcategories over the past 12
                                                  months.
                                                </>
                                              );
                                            }
                                          })()}
                                        </span>
                                      </Box>
                                    )}
                                  </Box>
                                )}
                            </Box>


                            {selectedView === "keyInsights" && (
<Box>
                            {topMovementsAnalysis &&
                            Object.keys(topMovementsAnalysis).length > 0 ? (
                              <TableContainer
                                sx={{
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                  marginTop: "16px",
                                }}
                              >
                                <Table
                                  sx={{
                                    backgroundColor: "#FFFFFF0F",
                                    borderRadius: "8px",
                                  }}
                                  aria-label="market outlook table"
                                >
                                  <TableHead>
                                    <TableRow sx={{ fontStyle: "Roboto" }}>
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontStyle: "Roboto",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          borderBottom: "1px solid #FFFFFF0F",
                                          backgroundColor: "#FFFFFF1F",
                                          textAlign: "left",
                                        }}
                                      >
                                        Category
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontStyle: "Roboto",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          borderBottom: "1px solid #FFFFFF0F",
                                          backgroundColor: "#FFFFFF1F",
                                          textAlign: "left",
                                        }}
                                      >
                                        Indicators
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontStyle: "Roboto",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          borderBottom: "1px solid #FFFFFF0F",
                                          backgroundColor: "#FFFFFF1F",
                                          textAlign: "left",
                                        }}
                                      >
                                        Outlook
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody sx={{ fontStyle: "Roboto" }}>
                                    {Object.keys(topMovementsAnalysis)
                                      .filter(
                                        (category) =>
                                          category !== "recommendation"
                                      ) // Exclude 'recommendation'
                                      .sort(
                                        (a, b) =>
                                          Math.abs(
                                            topMovementsAnalysis[b].movement
                                          ) -
                                          Math.abs(
                                            topMovementsAnalysis[a].movement
                                          )
                                      )
                                      .map((category) => {
                                        const categoryData =
                                          topMovementsAnalysis[category];
                                        const analysis =
                                          categoryData.analysis ||
                                          "No analysis available";

                                        const analysisParts =
                                          analysis.split("Sources:");
                                        const summaryText = analysisParts[0]
                                          .split("Indicators:")[0]
                                          .replace("Summary:", "")
                                          .trim();

                                        let sources = [];
                                        if (analysisParts.length > 1) {
                                          // Try to parse sources from the text
                                          try {
                                            const sourcesText =
                                              analysisParts[1].trim();
                                            // If sources are in format [url1, url2, url3]
                                            if (
                                              sourcesText.startsWith("[") &&
                                              sourcesText.endsWith("]")
                                            ) {
                                              // Remove brackets and split by commas
                                              sources = sourcesText
                                                .substring(
                                                  1,
                                                  sourcesText.length - 1
                                                )
                                                .split(",")
                                                .map((url) =>
                                                  url
                                                    .trim()
                                                    .replace(/^'|'$/g, "")
                                                );
                                            }
                                          } catch (e) {
                                            console.error(
                                              "Error parsing sources:",
                                              e
                                            );
                                          }
                                        }

                                        // Alternatively, if sources are directly in the categoryData
                                        if (
                                          categoryData.sources &&
                                          Array.isArray(categoryData.sources)
                                        ) {
                                          sources = categoryData.sources;
                                        }

                                        // Parse the indicators from the analysis text
                                        let indicators = {};

                                        if (analysis.includes("Indicators:")) {
                                          [
                                            "DEMAND",
                                            "SUPPLY",
                                            "PRICING",
                                          ].forEach((indicator) => {
                                            const regex = new RegExp(
                                              `${indicator}: (INCREASING|DECREASING|STABLE)`
                                            );
                                            const match = analysis.match(regex);
                                            const trend = match
                                              ? match[1]
                                              : "N/A";

                                            // Set arrow and color based on indicator type and trend
                                            let color = "yellow"; // Default for STABLE
                                            let arrow = (
                                              <PlayArrow
                                                sx={{
                                                  fontSize: 14,
                                                }}
                                              />
                                            );

                                            if (trend === "INCREASING") {
                                              arrow = "▲";
                                              // For DEMAND and PRICE, INCREASING is red; for SUPPLY, it's green
                                              color =
                                                indicator === "SUPPLY"
                                                  ? "green"
                                                  : "red";
                                            } else if (trend === "DECREASING") {
                                              arrow = "▼";
                                              // For DEMAND and PRICE, DECREASING is green; for SUPPLY, it's red
                                              color =
                                                indicator === "SUPPLY"
                                                  ? "red"
                                                  : "green";
                                            } else if (trend === "STABLE") {
                                              arrow = (
                                                <PlayArrow
                                                  sx={{
                                                    fontSize: 14,
                                                  }}
                                                />
                                              );
                                              color = "yellow";
                                            }

                                            indicators[
                                              indicator.toLowerCase()
                                            ] = { arrow, color, trend };
                                          });
                                        }

                                        return (
                                          <TableRow
                                            key={category}
                                            sx={{
                                              borderBottom:
                                                "1px solid #FFFFFF0F",
                                              fontSize: "14px",
                                              fontWeight: 500,
                                              lineHeight: "20px",
                                              textAlign: "left",
                                              "& td, & th": {
                                                borderBottom: "none",
                                              },
                                            }}
                                          >
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontSize: "12px",
                                                width: "15%",
                                              }}
                                            >
                                              {category}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontSize: "12px",
                                                width: "25%",
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  gap: "12px",
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Demand
                                                  {indicators.demand ? (
                                                    <span
                                                      style={{
                                                        display: "inline-flex", // Ensures inline flex for alignment
                                                        alignItems: "center", // Vertical alignment
                                                        color:
                                                          indicators.demand
                                                            .color,
                                                        fontWeight: "bold",
                                                        marginLeft: "4px",
                                                      }}
                                                    >
                                                      {indicators.demand.arrow}
                                                    </span>
                                                  ) : (
                                                    "N/A"
                                                  )}
                                                </Typography>
                                                <Typography
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Supply
                                                  {indicators.supply ? (
                                                    <span
                                                      style={{
                                                        display: "inline-flex", // Ensures inline flex for alignment
                                                        alignItems: "center", // Vertical alignment
                                                        color:
                                                          indicators.supply
                                                            .color,
                                                        fontWeight: "bold",
                                                        marginLeft: "4px",
                                                      }}
                                                    >
                                                      {indicators.supply.arrow}
                                                    </span>
                                                  ) : (
                                                    "N/A"
                                                  )}
                                                </Typography>
                                                <Typography
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Pricing
                                                  {indicators.pricing ? (
                                                    <span
                                                      style={{
                                                        display: "inline-flex", // Ensures inline flex for alignment
                                                        alignItems: "center", // Vertical alignment
                                                        color:
                                                          indicators.pricing
                                                            .color,
                                                        fontWeight: "bold",
                                                        marginLeft: "4px",
                                                      }}
                                                    >
                                                      {indicators.pricing.arrow}
                                                    </span>
                                                  ) : (
                                                    "N/A"
                                                  )}
                                                </Typography>
                                              </Box>
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontSize: "12px",
                                                // width: "60%",
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: "12px",
                                                  lineHeight: "1.4",
                                                }}
                                              >
                                                {summaryText
                                                  .replace(/['"]/g, "")
                                                  .split("***")
                                                  .filter((item) => item.trim()) // Keep only non-empty items
                                                  .map((item, index) => {
                                                    // Find the key and format it
                                                    const match =
                                                      item.match(
                                                        /([A-Z]+):(.*)/
                                                      );
                                                    let keyPart = null;
                                                    let contentPart = item;

                                                    if (match) {
                                                      const key = match[1];
                                                      const formattedKey =
                                                        key
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                        key
                                                          .slice(1)
                                                          .toLowerCase();
                                                      keyPart = (
                                                        <b>{formattedKey}:</b>
                                                      );
                                                      contentPart = match[2];
                                                    }

                                                    // Strip content from parentheses and square brackets
                                                    contentPart =
                                                      contentPart.replace(
                                                        /\([^)]*\)|\[[^\]]*\]|\)|\]/g,
                                                        ""
                                                      );

                                                    // Only render if there's actual content after trimming
                                                    const trimmedContent =
                                                      contentPart.trim();
                                                    if (!trimmedContent)
                                                      return null; // Skip empty content

                                                    return (
                                                      <div
                                                        key={index}
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                          marginBottom: "6px",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "8px",
                                                            color: "#FFFFFF",
                                                            fontSize: "14px",
                                                          }}
                                                        >
                                                          •
                                                        </span>
                                                        <div>
                                                          {keyPart}{" "}
                                                          {trimmedContent}
                                                        </div>
                                                      </div>
                                                    );
                                                  })
                                                  .filter(Boolean)}
                                              </Typography>

                                              {/* Display Sources */}
                                              {sources &&
                                                sources.length > 0 && (
                                                  <Box
                                                    sx={{
                                                      marginTop: "8px",
                                                      display: "flex",
                                                      flexWrap: "wrap",
                                                      gap: "8px",
                                                      marginLeft: "12px",
                                                    }}
                                                  >
                                                    <Typography
                                                      component="span"
                                                      sx={{
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      Sources:
                                                    </Typography>
                                                    {sources.map(
                                                      (url, index) => {
                                                        // Extract domain name from URL
                                                        let siteName;
                                                        try {
                                                          const domain =
                                                            new URL(url)
                                                              .hostname;
                                                          // Convert domain to site name (e.g., www.reuters.com -> reuters)
                                                          siteName = domain
                                                            .replace("www.", "")
                                                            .split(".")[0];
                                                          // Capitalize first letter
                                                          siteName =
                                                            siteName
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            siteName.slice(1);
                                                        } catch (e) {
                                                          siteName = `Source ${
                                                            index + 1
                                                          }`;
                                                        }

                                                        return (
                                                          <Typography
                                                            key={index}
                                                            component="a"
                                                            href={url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            sx={{
                                                              fontSize: "12px",
                                                              color: "#4dabf5",
                                                              textDecoration:
                                                                "none",
                                                              "&:hover": {
                                                                textDecoration:
                                                                  "underline",
                                                              },
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            {siteName}
                                                            {index <
                                                            sources.length - 1
                                                              ? ","
                                                              : ""}
                                                          </Typography>
                                                        );
                                                      }
                                                    )}
                                                  </Box>
                                                )}
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            ) : (
                              <Skeleton width="100%" height={20} />
                            )}
</Box>
                            )}


                          </Box>
                        )}

                      {/* Supplier Risk Assessment Section */}

                      {topcardCommentary &&
                        Object.entries(topcardCommentary).length > 0 && (
                          <Box
                            sx={{
                              border: "1px solid #FFFFFF1A",
                              borderRadius: "8px",
                              boxShadow: "0px 1px 2px 0px #1018280D",
                              padding: "12px",
                              backgroundColor: "#FFFFFF0F",
                              ml:1,
                              mt:2
                            }}
                          >
                            <Typography sx={{ fontWeight: 600, mb: 1 }}>
                              {selectedView === "recommendations"
                                ? "Supplier recommendations"
                                : "Supplier Risk Assessment"}
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                              }}
                            >
                              {/* Show full_insight value at the top */}
                              {topcardCommentary.full_insight && (
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    mb: 1,
                                    color: "white",
                                  }}
                                >
                                  {topcardCommentary.full_insight}
                                </Typography>
                              )}

                              {/* Show insight_high, insight_low, and insight_moderate in bullet points */}
                              {selectedView === "recommendations" && (
                                <Box
                                  component="ul"
                                  sx={{
                                    paddingLeft: 2,
                                    margin: 0,
                                    listStyleType: "disc",
                                  }}
                                >
                                  {[
                                    "insight_high",
                                    "insight_low",
                                    "insight_moderate",
                                  ]
                                    .filter((key) => topcardCommentary[key])
                                    .map((key) => (
                                      <li key={key}>
                                        <Typography
                                          sx={{
                                            fontSize: "14px",
                                            color: "white",
                                          }}
                                        >
                                          {topcardCommentary[key]}
                                        </Typography>
                                      </li>
                                    ))}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        )}
                    </>
                  </Box>
                </>
              </DialogContent>
            </Dialog>
          </Box>
        </Box>
      </Box>
      {/* </Box> */}

      {/* Spend Overview Section */}
      <Box
        id="Spend Overview"
         className="pdf-section"
        sx={{
          mb: 4,
          mt: 4,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <Typography
            sx={{
              fontStyle: "Roboto",
              fontSize: "16px",
              fontWeight: 700,
              lineHeight: "18px",
              color: "white",
              gap: "7px",
            }}
          >
            <Toll
              sx={{
                mr: 0.5,
                width: "16px",
                height: "16px",
                color: "#FFFFFF99",
              }}
            />
            Category Overview
          </Typography>
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>

        <Box sx={{ width: "100%", height: "1px", mb: 2 }} />

        <Grid container spacing={3} sx={{ height: "240px" }}>
          <Grid item xs={12} md={4} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {spendSummary.spend_summary.overall_spend ? (
                <AnimatedInfoCard
                  delay={1000}
                  icon={card.icon}
                  title={card.title}
                  content={card.content}
                />
              ) : (
                <LoadingGif />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {categorySummary.category_summary.num_l1_categories ? (
                <AnimatedInfoCard
                  delay={2000}
                  icon={card1.icon}
                  title={card1.title}
                  content={card1.content}
                />
              ) : (
                <LoadingGif />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {supplierSummary.supplier_summary.total_suppliers ? (
                <AnimatedInfoCard
                  delay={3000}
                  icon={card2.icon}
                  title={card2.title}
                  content={card2.content}
                />
              ) : (
                <LoadingGif />
              )}
            </Box>
          </Grid>
        </Grid>

        {/* {loading && !dashboardData && <LoadingGif />} */}
      </Box>

      {/* Category Overview Section */}
      <Box
        id="Category Spend Summary"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            flex: 1,
          }}
        >
          <RxDashboard
            style={{
              width: "14px",
              height: "14px",
              color: "#FFFFFF99",
            }}
          />
          <Typography
            sx={{
              fontStyle: "Roboto",
              fontSize: "16px",
              fontWeight: 700,
              lineHeight: "18px",
              color: "white",
            }}
          >
            Category Insights
          </Typography>

          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>

        <Box sx={{ width: "100%", height: "1px", mb: 2, width: "100%" }} />
        <Box
          sx={{
            // backgroundColor: "#FFFFFF08",
            // borderRadius: "8px",
            padding: 2,
            width: "100%",
          }}
        >
          {categoryChartData && categoryChartDataL1 && (
            //  <Box sx={{ backgroundColor: "rgba(129, 129, 129, 0.25)", borderRadius: "30px", padding: 2, width: "100%" }}>
            <Fade in={true} timeout={1000}>
              <Box
              className="pdf-section"
                style={{
                  width: "100%",
                  // height: "60vh",
                  // marginBottom: "2rem",
                }}
              >
                <HistogramChart
                  chartData={categoryChartData}
                  categoryChartDataL1={categoryChartDataL1}
                  spendSummary={spendSummary}
                  roleTitle={roleTitle}
                  barColor="lightblue"
                />
              </Box>
            </Fade>
            //  </Box>
          )}
       {topCategories != "" ? (
            // <Box sx={{ backgroundColor: "rgba(129, 129, 129, 0.25)", borderRadius: "30px", padding: 2, width: "100%" }}>

            <InsightContainer
              title="Insights"
              topCategories={topCategories}
              topContributors={topContributors}
              marketSize={marketSize}
              categoryDict={categoryDict}
              costStructure={costStructure}
              demandandSupply={demandandSupply}
              topSuppliers={topSuppliers}
              categoryChartData={categoryChartData}
              categoryChartDataL1={categoryChartDataL1}
              clientNames={clientNames}
              categoryNews={categoryNews}
              indiSummaries={indiSummaries}
              globalSummaries={globalSummaries}
              csSrc={csSrc}
              porterForces={porterForces}
              catandSpend={catandSpend}
              marketImplications={marketImplications}
              filteredResults={filteredResults}
              costStructureMovements={costStructureMovements}
            />
          ) : (
            // </Box>
            <LoadingGif />
          )}
          {/* 
                  <div style={{ marginTop: "2rem" }}>
                    {filteredResults.result &&
                    filteredResults.result.length > 0 ? (
                      // <CommodityPriceChart
                        filteredResults={filteredResults.result}
                        costStructureMovements={costStructureMovements}
                      />
                    ) : (
                      <LoadingGif />
                    )}
                  </div> */}
        </Box>
      </Box>



      {/* {Market Overview Section} */}
      {/* <Box
              id="Market Overview"
              sx={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                mt: 4,
                position: "relative",
              }}
            >
              {/* <MUITooltip
      title={
        <Typography sx={{ fontStyle: 'italic',fontSize: "14px", }}>
          Indicates degree of emissions (in KgCO2) and spend by category
        </Typography>
      }
      arrow
      placement="right"
      enterDelay={500}
      leaveDelay={200}
    > */}
      {/* <Typography
                variant="h6"
                sx={{
                  fontStyle: "Roboto",
                  fontSize: "18px",
                  fontWeight: 700,
                  lineHeight: "18px",
                  color: "white",
                  display: "inline-flex", // Change to inline-flex
                  alignItems: "center",
                  cursor: "pointer",
                  position: "relative", // Add this
                  zIndex: 1, // Add this
                }}
              >
                <InsightsOutlined sx={{ mr: 1 }} />
                Market Overview
              </Typography>
              {/* </MUITooltip> */}
      {/* <Box
                sx={{ width: "100%", height: "1px", mb: 2, width: "100%" }}
              />
              <Box
                sx={{
                  backgroundColor: "#FFFFFF08",
                  borderRadius: "8px",
                  padding: 2,
                  width: "100%",
                }}
              >
                {top10categories && (
                  <Fade in={true} timeout={1000}>
                    <Box
                      style={{
                        width: "100%",
                        height: "auto",
                        marginBottom: "1rem",
                      }}
                    >
                      {!categoryPart1Response ||
                      Object.keys(categoryPart1Response).length === 0 ? (
                        <LoadingGif />
                      ) : (
                        <MarketTable
                          categoryPart1Response={categoryPart1Response}
                          categoryPart2Response={categoryPart2Response}
                          categoryPart3Response={categoryPart3Response}
                          categoryPart4Response={categoryPart4Response}
                          categoryPart5Response={categoryPart5Response}
                          categoryPart6Response={categoryPart6Response}
                          categoryPart7Response={categoryPart7Response}
                          categoryPart8Response={categoryPart8Response}
                          categoryPart9Response={categoryPart9Response}
                          categoryPart10Response={categoryPart10Response}
                          forecast={forecast}
                          spendSummary={spendSummary}
                        />
                      )}
                    </Box>
                  </Fade>
                )}
              </Box>
            </Box>   */}

      {/* Supplier Overview Section */}
      <Box id="Supplier Overview" sx={{ mt: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Typography
              sx={{
                fontStyle: "Roboto",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "18px",
                color: "white",
              }}
            >
              <RiBuildingLine
                style={{
                  width: "14px",
                  height: "14px",
                  color: "#FFFFFF99",
                  marginRight: 4,
                }}
              />
              Supplier Overview
            </Typography>
          </Box>
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>
        <Box sx={{ width: "100%", height: "1px", mb: 2 }} />
        <Box
          sx={{
            // backgroundColor: "#FFFFFF08",
            borderRadius: "8px",
            padding: 2,
          }}
        >
          {supplierChartData && (
            <Fade in={true} timeout={1000}>
              <Box
              className="pdf-section"
                style={{
                  width: "100%",
                  // height: "80vh",
                  marginBottom: "3rem",
                }}
              >
                <SupplierChartFunc
                  supplierChartData={supplierChartData}
                  spendSummary={spendSummary}
                  roleTitle={roleTitle}
                />
                {/* <SupplierTableFunc supplierTableData={supplierTableData} /> */}
              </Box>
            </Fade>
          )}
          {top3CategoriesSup != "" ? (
            <SupplierInsightContainer
              title="Insights"
              // supplierChartData={supplierChartData}
              // insights={supplierInsights}
              top3CategoriesSup={top3CategoriesSup}
              supDandP={supDandP}
              supCustInfo={supCustInfo}
              riskScore={riskScore}
              scoreCommentary={scoreCommentary}
              revenue={revenue}
              supplierNews={supplierNews}
              spendSummary={spendSummary}
              supplierProData={supplierProData}
              kpdbData={kpdbData}
              roleTitle={roleTitle}
            />
          ) : (
            // </Box>
            <LoadingGif />
          )}
        </Box>
      </Box>

            {/* {Carbon Chart Section} */}
            <Box
        id="Carbon Emissions"
        className="pdf-section"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          mt: 4,
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <MUITooltip
            title={
              <Typography sx={{ fontStyle: "italic", fontSize: "14px" }}>
                Indicates Scope 3 emissions by category
              </Typography>
            }
            arrow
            placement="right"
            enterDelay={500}
            leaveDelay={200}
          >
            <Typography
              sx={{
                fontStyle: "Roboto",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "18px",
                color: "white",
                display: "inline-flex", // Change to inline-flex
                alignItems: "center",
                cursor: "pointer",
                position: "relative", // Add this
                zIndex: 1, // Add this
              }}
            >
              <EnergySavingsLeaf
                sx={{
                  mr: 0.5,
                  width: "16px",
                  height: "16px",
                  color: "#FFFFFF99",
                }}
              />
              Carbon Emissions
            </Typography>
          </MUITooltip>
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>
        <Box sx={{ width: "100%", height: "1px", mb: 2, width: "100%" }} />
        <Box
          sx={{
            backgroundColor: "#FFFFFF08",
            borderRadius: "8px",
            padding: 2,
            width: "100%",
          }}
        >
          {spendSummary &&
          carbonTable &&
          Object.keys(carbonTable).length > 0 ? (
            <Fade in={true} timeout={1000}>
              <Box
                style={{
                  width: "100%",
                  // height: "110vh",
                  marginBottom: "2rem",
                }}
              >
                <CarbonChart
                  carbonEmission={carbonEmission}
                  carbonTable={carbonTable}
                  spendSummary={spendSummary}
                />
              </Box>
            </Fade>
          ) : (
            <LoadingGif />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AnalyticsSectionCM;
